import {PortalService} from '../../vna_portal/model/PortalService';

export class CampService extends PortalService {

    campType: string;
    campName: string;
    pkCamp: number;

    constructor(campData: Object){
        super(campData);

        this.campType = campData['camp_type'];
        this.campName = campData['camp_name'];
        this.pkCamp = campData['pk_camp'];
    }

    getCampType(): string {
        return this.campType;
    }

    getCampName(): string {
        return this.campName;
    }

    getPkCamp(): number {
        return this.pkCamp;
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/model/CampService.ts